<template>
  <div class="webcam">
    <a :href="`#${linkId}`" @click.prevent="openModal()">
      <img :src="src" :alt="altText" :id="linkId" />
      <div class="webcam-title o-65">{{ title }}</div>
    </a>
  </div>
</template>

<script>
export default {
  name: 'WebcamHooper',
  props: ['webcam', 'webcamTitleField'],
  computed: {
    linkId() {
      return `${this.webcam.Title.replace(' ', '-')}-webcam`;
    },
    title() {
      return this.webcam[this.webcamTitleField];
    },
    altText() {
      return `View of conditions at ${this.webcam.Title}`;
    },
    src() {
      return this.webcam.ThumbnailUrl;
    },
  },
  methods: {
    openModal() {
      this.$emit('showWebcamModal', this);
    },
  },
};
</script>

<style lang="scss" scoped>
.webcam {
  height: auto;
  a {
    color: $dark-gray;
    font-size: 14px;
    font-family: $base-font-regular;
    letter-spacing: 0;
    line-height: 1.2;
    text-decoration: none;
  }
  .webcam-title {
    text-transform: uppercase;
  }
  img {
    max-height: 160px;
  }
}
</style>
